import { Link } from '@mui/material';
import { EventPatientProfile } from '@revenuewell/front-end-bundle';
import { FC } from 'react';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';
import { getStatusIcon } from '../../../../../shared/alert/status-icon/status-icon-factory';
import { PatientProfileHeader } from '../../header/header';
import { QuickNavMenu } from '../../header/quick-nav-menu/quick-nav-menu';
import { ViewContent } from '../shared/view-content/view-content';
import { StatusList, StatusListItem } from './alerts-tasks.styles';

import { AlertsTasksSkeleton } from './alerts-tasks.skeleton';

export const AlertsAndTasksView: FC = () => {
  const { publish } = useEventBus();
  const { patientInfo, isLoadingAlerts } = usePatientProfile();

  const responsiblePartyClick = (patientId: number) => {
    publish({
      messageType: 'patientProfile',
      data: { patientId } as EventPatientProfile['data']
    });
  };

  return (
    <>
      <PatientProfileHeader />
      <QuickNavMenu />
      <ViewContent>
        <StatusList>
          {isLoadingAlerts && <AlertsTasksSkeleton />}
          {!patientInfo?.patientAlerts ||
            (patientInfo.patientAlerts.length === 0 && <StatusListItem text="Patient has no alerts or tasks" />)}
          {!isLoadingAlerts &&
            patientInfo.patientAlerts &&
            patientInfo.patientAlerts.map((x, i) => (
              <StatusListItem
                key={i}
                text={x.alert}
                icon={getStatusIcon(x.alert).icon}
                iconcolor={getStatusIcon(x.alert).color}
              >
                {x.patientId != patientInfo.id && (
                  <Link onClick={() => responsiblePartyClick(x.patientId)} sx={{ marginTop: '6px', display: 'flex' }}>
                    {`${x.firstName} ${x.lastName}`}
                  </Link>
                )}
              </StatusListItem>
            ))}
        </StatusList>
      </ViewContent>
    </>
  );
};
